/**
 * Created by vedi on 29/08/2017.
 */

import { Container } from 'pixi.js';

import object from './object';

export default params => object(params, Container);
